// plugins/tenant.client.ts

import {defineNuxtPlugin} from '#app'
import {useLogger} from '@/utils/logger'
const logger = useLogger('tenant.client')

export default defineNuxtPlugin((nuxtApp) => {
  logger.debug('tenant.client.ts plugin executing')

  // CSR에서 직접 접근할 때도 서브도메인 감지
  if (import.meta.client) {
    const payload = useNuxtApp().payload

    // 이미 payload에 subdomain이 있으면 사용
    if (payload.subdomain) {
      logger.debug(`Client: Using existing subdomain from payload: ${payload.subdomain}`)
      return
    }

    // 없으면 현재 URL에서 직접 파싱
    const hostname = window.location.hostname
    logger.debug(`Client: Detecting subdomain from hostname: ${hostname}`)

    let subdomain = hostname

    // 서버의 getTenantData 로직과 유사하게 구현
    const mainDomain = ["localhost", "webeasy.co.kr", "www.webeasy.co.kr", "staging.webeasy.co.kr"]
    const stagingDomain = "staging.webeasy.co.kr"

    // 메인 도메인인지 확인
    if (mainDomain.includes(hostname)) {
      logger.debug('Client: Main domain detected, no subdomain')
      payload.subdomain = undefined
      return
    }

    // 1. 스테이징 환경 체크
    if (hostname.endsWith(`.${stagingDomain}`)) {
      subdomain = hostname.replace(`.${stagingDomain}`, "")
      logger.debug(`Client: Staging subdomain detected: ${subdomain}`)
    }
    // 2. 프로덕션 환경 체크
    else if (hostname.endsWith(`.webeasy.co.kr`)) {
      subdomain = hostname.replace(`.webeasy.co.kr`, "")
      logger.debug(`Client: Production subdomain detected: ${subdomain}`)
    }
    // 3. 로컬 개발 환경 체크
    else if (hostname.endsWith(`.localhost`)) {
      subdomain = hostname.replace(`.localhost`, "")
      logger.debug(`Client: Local subdomain detected: ${subdomain}`)
    }

    // payload에 설정
    payload.subdomain = subdomain
    logger.debug(`Client: Set subdomain in payload: ${subdomain}`)

    // useState에 설정 (만약 useTenant가 이미 호출되었다면)
    const subdomainState = useState('subdomain')
    if (subdomainState.value === undefined) {
      subdomainState.value = subdomain
      logger.debug(`Client: Updated useState for subdomain: ${subdomain}`)
    }
  }
})
